/** To differentiate parked orders cheques from regular cheques on tables we use this as the value in cheque.tableId */
export const PARKED_ORDER_TABLE_ID = 'parked-order';
